<script>
import { mapState } from 'vuex'
import date from 'locutus/php/datetime/date'
import PageNavigation from '@components/admin/page-navigation'
import { fetchLogList } from '@apis/admin/affiliate'
import fromPairs from 'lodash/fromPairs'
import map from 'lodash/map'

export default {
  components: { PageNavigation },
  data() {
    return {
      loading: false,
      list: [],
      total_count: 0,
      page: 1,
      total_page: 0,
      page_navigation: {},
      search_params: {},
      count_groups: null,
      view_mode: 'TABLE',
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  watch: {
    $route(to, from) {
      this.page = this.$route.query.page || 1
      this.loadList().catch((e) => this.$toasted.error(e.message))
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.page = this.$route.query.page || 1
      this.search_params = { ...this.$route.query }
      Promise.all([this.loadList()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadList() {
      this.loading = true
      const ret_obj = await fetchLogList({
        ...this.$route.params,
        ...this.$route.query,
      })

      this.count_groups = this.countByGroup(ret_obj.data, [
        'log_seq',
        'log_policy_seq',
        'log_beneficiary_seq',
      ])
      this.list = ret_obj.data
      this.total_count = ret_obj.total_count
      this.total_page = ret_obj.total_page
      this.page_navigation = ret_obj.page_navigation
    },
    search() {
      this.$router.push({ query: this.search_params })
    },
    handleShowLogVars(log_seq) {
      this.s_log_seq = log_seq
      this.show_log_vars = true
    },
    countByGroup(items, fields) {
      const count_groups = fromPairs(
        map(fields, (val) => [val, { counts: {}, first_indexes: [] }])
      )
      const cur_value = fromPairs(map(fields, (val) => [val, null]))

      items.forEach((item, idx) => {
        fields.forEach((field) => {
          if (cur_value[field] !== item[field]) {
            count_groups[field].first_indexes.push(idx)
            cur_value[field] = item[field]
          }

          const counts = count_groups[field].counts

          counts[item[field]] = counts[item[field]] || 0
          counts[item[field]]++
        })
      })

      return count_groups
    },
    date,
    fromPairs,
  },
}
</script>

<template>
  <div v-loading="loading">
    <h3 :class="$style.xeAdmin">{{ $t('affiliate_log_list.search') }}</h3>
    <form @submit.prevent="search">
      <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
        <colgroup>
          <col width="20%" />
          <col width="30%" />
          <col width="20%" />
          <col width="30%" />
        </colgroup>
        <tbody>
          <tr>
            <th scope="col">
              <div>
                <select
                  v-model="search_params.search_target"
                  :class="$style.fullWidth"
                >
                  <option
                    v-for="val in [
                      [undefined, $t('admin.search_target')],
                      ['user_id', $t('admin.user_id')],
                      ['email_address', $t('admin.email_address')],
                      ['user_name', $t('admin.user_name')],
                      ['ipaddress', $t('admin.ipaddress')],
                      ['user_agent', $t('admin.user_agent')],
                      ['regdate_more', $t('admin.login_log_regdate_more')],
                      ['regdate_less', $t('admin.login_log_regdate_less')],
                    ]"
                    :key="val[1]"
                    :value="val[0]"
                    >{{ val[1] }}</option
                  >
                </select>
              </div>
            </th>
            <td>
              <input
                v-model="search_params.search_keyword"
                :placeholder="$t('admin.search_word')"
                type="text"
                :class="[$style.inputTypeText, $style.fullWidth]"
              />
            </td>
            <td colspan="2">
              <ElCheckbox
                v-model="search_params.use_statistics_exclude"
                :false-label="undefined"
                true-label="N"
                >{{
                  $t('affiliate_log_list.use_statistics_exclude')
                }}</ElCheckbox
              >
              <ElCheckbox
                v-model="search_params.member_is_alive"
                :false-label="undefined"
                true-label="Y"
                >{{ $t('affiliate_log_list.member_is_alive') }}</ElCheckbox
              >
            </td>
          </tr>
          <tr>
            <th scope="col"
              ><div>{{ $t('affiliate_log_list.target_action') }}</div></th
            >
            <td>
              <el-select
                v-model="search_params.target_action"
                filterable
                :placeholder="$t('affiliate_log_list.all')"
              >
                <el-option
                  v-for="val in [
                    [undefined, $t('admin.total')],
                    ...constants.affiliate.policy.target_action,
                  ]"
                  :key="val[0]"
                  :value="val[0]"
                  :label="val[1]"
                >
                </el-option>
              </el-select>
            </td>
            <th scope="col"
              ><div>{{ $t('affiliate_log_list.target_seq') }}</div></th
            >
            <td>
              <input
                v-model="search_params.target_seq"
                type="text"
                :class="[$style.inputTypeText, $style.w80]"
              />
            </td>
          </tr>
          <tr>
            <th scope="col"
              ><div>{{ $t('admin.sort') }}</div></th
            >
            <td>
              <select v-model="search_params.sort_order">
                <option
                  v-for="val in [
                    [undefined, $t('admin.regdate')],
                    ['last_login', $t('admin.last_login')],
                  ]"
                  :key="val[1]"
                  :value="val[0]"
                  >{{ val[1] }}</option
                >
              </select>
              <select v-model="search_params.order_type">
                <option
                  v-for="val in [
                    [undefined, $t('admin.desc')],
                    ['asc', $t('admin.asc')],
                  ]"
                  :key="val[1]"
                  :value="val[0]"
                  >{{ val[1] }}</option
                >
              </select>
            </td>
          </tr>
          <tr>
            <th colspan="4" :class="$style.button">
              <a
                href="#"
                :class="[$style.button, $style.red]"
                @click.prevent="
                  search_params = {}
                  search
                "
                ><span>{{ $t('admin.reset') }}</span></a
              >
              &nbsp;
              <span :class="[$style.button, $style.black]"
                ><input type="submit" :value="$t('admin.submit')"
              /></span>
            </th>
          </tr>
        </tbody>
      </table>
    </form>
    <h3 :class="$style.xeAdmin">{{
      $t('affiliate_log_list.payment_history')
    }}</h3>
    <fieldset>
      <div :class="$style.fr">
        <label>
          <input
            v-model="view_mode"
            type="checkbox"
            :true-value="'DESCRIBE'"
            :false-value="'TABLE'"
          />
          {{ $t('affiliate_log_list.easy_info') }}
        </label>
      </div>
    </fieldset>
    <table
      v-if="view_mode === 'TABLE'"
      cellspacing="0"
      cellpadding="0"
      :class="$style.crossTable"
    >
      <caption v-if="!loading"
        >Total {{ total_count }}, Page {{ page }}/{{ total_page }}</caption
      >
      <thead>
        <tr>
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.occurrence_target') }}</div></th
          >
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.behavior_type') }}</div></th
          >
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.target_unique_number') }}</div></th
          >
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.occurrence_date') }}</div></th
          >
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.applied_policy_name') }}</div></th
          >
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.beneficiary_type') }}</div></th
          >
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.beneficiary') }}</div></th
          >
          <th scope="col" rowspan="2"
            ><div
              ><a href="#">{{ $t('affiliate_log_list.number') }}</a></div
            ></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.benefit_type') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{
              $t('affiliate_log_list.principal_amount_target')
            }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.allowance_assets') }}</div></th
          >
        </tr>
        <tr>
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.benefit') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.principal_amount') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.allowance_amount') }}</div></th
          >
        </tr>
      </thead>
      <tbody>
        <template v-for="(data, idx) in list">
          <tr :key="`${data.log_benefactor_seq}-1`">
            <template
              v-if="count_groups.log_seq.first_indexes.indexOf(idx) !== -1"
            >
              <td
                :class="[$style.center, $style.nowrap]"
                :rowspan="count_groups.log_seq.counts[data.log_seq] * 2"
                >{{ data.causer_user_id }}</td
              >
              <td
                :class="[$style.center, $style.nowrap]"
                :rowspan="count_groups.log_seq.counts[data.log_seq] * 2"
                >{{
                  fromPairs(constants.affiliate.policy.target_action)[
                    data.target_action
                  ]
                }}</td
              >
              <td
                :class="[$style.nowrap]"
                :rowspan="count_groups.log_seq.counts[data.log_seq] * 2"
                >{{ data.target_seq }}</td
              >
              <td
                :class="[$style.center, $style.nowrap]"
                :rowspan="count_groups.log_seq.counts[data.log_seq] * 2"
                >{{ date('Y-m-d H:i:s', new Date(data.regdate)) }}</td
              >
            </template>
            <template
              v-if="
                count_groups.log_policy_seq.first_indexes.indexOf(idx) !== -1
              "
            >
              <td
                :class="[$style.wide]"
                :rowspan="
                  count_groups.log_policy_seq.counts[data.log_policy_seq] * 2
                "
                >{{ data.policy_title }}</td
              >
            </template>
            <template
              v-if="
                count_groups.log_beneficiary_seq.first_indexes.indexOf(idx) !==
                  -1
              "
            >
              <td
                :class="[
                  $style.tCenter,
                  $style.nowrap,
                  { [$style.fsI]: data.beneficiary_member_seq === -2 },
                ]"
                :rowspan="
                  count_groups.log_beneficiary_seq.counts[
                    data.log_beneficiary_seq
                  ] * 2
                "
                :colspan="data.beneficiary_member_seq === -2 ? 2 : 1"
                >{{
                  fromPairs(
                    constants.affiliate.policy_beneficiary.beneficiary_type[
                      data.target_action
                    ]
                  )[data.beneficiary_type]
                }}</td
              >
              <td
                v-if="data.beneficiary_type !== 'BROKERAGE'"
                :class="[$style.center, $style.nowrap]"
                :rowspan="
                  count_groups.log_beneficiary_seq.counts[
                    data.log_beneficiary_seq
                  ] * 2
                "
                >{{ data.beneficiary_user_id }}</td
              >
            </template>
            <td
              :class="[
                { [$style.row2]: data._no % 2 },
                $style.center,
                $style.tCenter,
                $style.nowrap,
              ]"
              rowspan="2"
              >{{ `${data._no}` | numberFormat }}</td
            >
            <td
              :rowspan="data.benefactor_member_seq === -1 ? 2 : false"
              :class="[
                { [$style.row2]: data._no % 2 },
                $style.center,
                $style.tCenter,
                $style.nowrap,
              ]"
              >{{
                fromPairs(
                  constants.affiliate.policy_benefactor.benefactor_type[
                    data.target_action
                  ]
                )[data.benefactor_type]
              }}</td
            >
            <td
              :class="[
                { [$style.row2]: data._no % 2 },
                $style.center,
                $style.tCenter,
                $style.nowrap,
              ]"
              >{{
                fromPairs(
                  constants.affiliate.policy_benefactor.base_amount_target[
                    data.target_action
                  ]
                )[data.base_amount_target]
              }}</td
            >
            <td
              :class="[
                { [$style.row2]: data._no % 2 },
                $style.center,
                $style.nowrap,
              ]"
              >{{ data.asset_title }}</td
            >
          </tr>
          <tr :key="`${data.log_benefactor_seq}-2`">
            <td
              v-if="data.benefactor_member_seq !== -1"
              :class="[
                { [$style.row2]: data._no % 2 },
                $style.center,
                $style.tCenter,
                $style.nowrap,
              ]"
              >{{ data.benefactor_user_id }}</td
            >
            <td
              :class="[
                { [$style.row2]: data._no % 2 },
                $style.tRight,
                $style.nowrap,
              ]"
              >{{ data.base_amount | trimDecimalZero | numberFormat }}</td
            >
            <td
              :class="[
                { [$style.row2]: data._no % 2 },
                $style.tRight,
                $style.nowrap,
              ]"
            >
              {{ data.amount | trimDecimalZero | numberFormat }}
              <template v-if="data.base_amount_target !== '__FIXED__'">
                ({{ data.policy_amount | trimDecimalZero | numberFormat }}%)
              </template>
            </td>
          </tr>
        </template>
        <tr v-if="loading">
          <td :colspan="11" :class="[$style.tCenter, $style.center]">{{
            $t('admin.loading')
          }}</td>
        </tr>
        <tr v-else-if="!list.length">
          <td :colspan="11" :class="[$style.tCenter, $style.center]">{{
            $t('affiliate_log_list.msg_allowance_amount_no')
          }}</td>
        </tr>
      </tbody>
    </table>
    <table
      v-if="view_mode === 'DESCRIBE'"
      cellspacing="0"
      cellpadding="0"
      :class="$style.crossTable"
    >
      <caption v-if="!loading"
        >Total {{ total_count }}, Page {{ page }}/{{ total_page }}</caption
      >
      <thead>
        <tr>
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.occurrence_info') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.policy_info') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.beneficiary_info') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('affiliate_log_list.benefit_info') }}</div></th
          >
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, idx) in list" :key="data.log_benefactor_seq">
          <template
            v-if="count_groups.log_seq.first_indexes.indexOf(idx) !== -1"
          >
            <td
              :class="[$style.center, $style.tCenter, $style.nowrap]"
              :rowspan="count_groups.log_seq.counts[data.log_seq]"
            >
              <ruby
                >{{ date('Y-m-d H:i:s', new Date(data.regdate))
                }}<rt>발생일</rt></ruby
              >
              에 <ruby>{{ data.causer_user_id }}<rt>발생자</rt></ruby> 님의
              <ruby
                >{{
                  fromPairs(constants.affiliate.policy.target_action)[
                    data.target_action
                  ]
                }}<rt>행동 유형</rt></ruby
              >
              행위가 발생하여
            </td>
          </template>
          <template
            v-if="count_groups.log_policy_seq.first_indexes.indexOf(idx) !== -1"
          >
            <td
              :class="[$style.center, $style.tCenter, $style.nowrap]"
              :rowspan="count_groups.log_policy_seq.counts[data.log_policy_seq]"
              ><ruby>{{ data.policy_title }}<rt>적용 정책명</rt></ruby> 정책에
              의거</td
            >
          </template>
          <template
            v-if="
              count_groups.log_beneficiary_seq.first_indexes.indexOf(idx) !== -1
            "
          >
            <td
              :class="[$style.center, $style.tCenter, $style.nowrap]"
              :rowspan="
                count_groups.log_beneficiary_seq.counts[
                  data.log_beneficiary_seq
                ]
              "
              ><ruby
                >{{
                  fromPairs(
                    constants.affiliate.policy_beneficiary.beneficiary_type[
                      data.target_action
                    ]
                  )[data.beneficiary_type]
                }}<rt>수혜자 유형</rt></ruby
              >
              <template v-if="data.beneficiary_member_seq === -2">
                집단에게
              </template>
              <template v-else>
                인
                <ruby>{{ data.beneficiary_user_id }}<rt>수혜자</rt></ruby>
                님께
              </template>
            </td>
          </template>
          <td
            :class="[
              { [$style.row2]: data._no % 2 },
              $style.center,
              $style.tCenter,
              $style.nowrap,
            ]"
            ><ruby
              >{{
                fromPairs(
                  constants.affiliate.policy_benefactor.benefactor_type[
                    data.target_action
                  ]
                )[data.benefactor_type]
              }}<rt>시혜자 유형</rt></ruby
            ><template v-if="data.benefactor_member_seq !== -1"
              >인
              <ruby>{{ data.benefactor_user_id }}<rt>시혜자</rt></ruby>
              님</template
            >이
            <ruby
              >{{
                fromPairs(
                  constants.affiliate.policy_benefactor.base_amount_target[
                    data.target_action
                  ]
                )[data.base_amount_target]
              }}<rt>원금액 대상</rt></ruby
            >{{ ' ' }}
            <template v-if="data.base_amount_target === '__FIXED__'">
              으로
              <ruby>{{ data.asset_title }}<rt>수당 자산</rt></ruby
              >로
              <ruby
                >{{ data.policy_amount | trimDecimalZero | numberFormat
                }}<rt>수당 정책 지정 수당 금액</rt></ruby
              >
              지급
            </template>
            <template v-else>
              <ruby
                >{{ data.base_amount | trimDecimalZero | numberFormat
                }}<rt>원금액</rt></ruby
              >
              중
              <ruby
                >{{ data.policy_amount | trimDecimalZero | numberFormat }}%<rt
                  >수당 정책 지정 수당 금액</rt
                ></ruby
              >를 계산하여 <ruby>{{ data.asset_title }}<rt>수당 자산</rt></ruby
              >로
              <ruby
                >{{ data.amount | trimDecimalZero | numberFormat
                }}<rt>수당 금액</rt></ruby
              >
              지급
            </template>
          </td>
        </tr>
        <tr v-if="loading">
          <td :colspan="4" :class="[$style.tCenter, $style.center]">{{
            $t('admin.loading')
          }}</td>
        </tr>
        <tr v-else-if="!list.length">
          <td :colspan="4" :class="[$style.tCenter, $style.center]">{{
            $t('affiliate_log_list.msg_allowance_amount_no')
          }}</td>
        </tr>
      </tbody>
    </table>
    <PageNavigation
      v-if="!loading"
      :total_count="total_count"
      :total_page="page_navigation.total_page"
      :cur_page="page"
      :page_count="page_navigation.page_count"
    ></PageNavigation>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';

.crossTable th,
.crossTable td {
  vertical-align: middle;
}
.adminTable,
.crossTable {
  // display: block;
  overflow: auto;
  ruby > rt {
    text-align: center;
  }
  ruby {
    font-weight: bold;
    color: #0068c1;
  }
  .row2 {
    background-color: #f3f3f3;
  }
}
</style>
